import { render, staticRenderFns } from "./AddWidgetDialog.vue?vue&type=template&id=3438fc06&"
import script from "./AddWidgetDialog.vue?vue&type=script&lang=js&"
export * from "./AddWidgetDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddWidgetDialog.vue?vue&type=style&index=0&id=3438fc06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports